import { render, staticRenderFns } from "./GoogleMyBusiness.vue?vue&type=template&id=53395004&scoped=true"
import script from "./GoogleMyBusiness.vue?vue&type=script&lang=js"
export * from "./GoogleMyBusiness.vue?vue&type=script&lang=js"
import style0 from "./GoogleMyBusiness.vue?vue&type=style&index=0&id=53395004&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53395004",
  null
  
)

export default component.exports